import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

export class BcApi {

  constructor(protected http: HttpClient, protected serverRoot: string, protected simorigin: string) {
  }

  getRecentOrders(): Observable<any> {
    return this.http.get(this.serverRoot + '/orders');
  }

  getOrderDetails(orderId: string) {
    return this.http.get(this.serverRoot + '/orders/' + orderId);
  }
}
